import { render, staticRenderFns } from "./TipboxPreview.vue?vue&type=template&id=67593e65"
import script from "./TipboxPreview.vue?vue&type=script&lang=js"
export * from "./TipboxPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports